/** Normalize API / i18n tag names so "love_collection", "cat_love", and "Love" match. */
export const normalizeLibraryTagKey = (name?: string | null): string => {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/^cat[_-\s]+/, "")
    .replace(/_collection$/g, "")
    .replace(/_da$/g, "")
    .replace(/[_-]+/g, " ")
    .trim();
};

const GRIFFIN_HIDDEN_CATEGORIES = new Set(["love", "scary", "spooky"]);

const GRIFFIN_HIDDEN_CEFR = new Set(["a3"]);

export const isHiddenGriffinCategory = (name?: string | null): boolean => {
  const key = normalizeLibraryTagKey(name);
  return key.length > 0 && GRIFFIN_HIDDEN_CATEGORIES.has(key);
};

export const isHiddenGriffinCefr = (name?: string | null): boolean => {
  const key = normalizeLibraryTagKey(name).replace(/^cefr\s*/, "");
  return key.length > 0 && GRIFFIN_HIDDEN_CEFR.has(key);
};
